import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethirteen-courses',
  templateUrl: './homethirteen-courses.component.html',
  styleUrls: ['./homethirteen-courses.component.scss']
})
export class HomethirteenCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
